
import {
    PSectionAgencies,
    PSectionAnnouncements,
    PSectionBalanceRequests,
    PSectionFinancialRequests,
    PSectionInsuranceRequests,
    PSectionReports,
    PSectionUsers,
    PermissionReportAdvancedReports,
} from './Permissions';
export const AppAgencyMenu = (permissions, lang) => {
    return [
        {
            path: "/home",
            title: window.sys_app_translate("Home", lang),
            subMenu: null,
            icon: "home",
        },
        permissions[PSectionInsuranceRequests]["view-all"] ||
            permissions[PSectionInsuranceRequests]["create"]
            ? {
                path: PSectionInsuranceRequests,
                title: window.sys_app_translate("Insurances", lang),
                subMenu: null,
                icon: "insurances",
                subMenu: [
                    permissions[PSectionInsuranceRequests]["create"]
                        ? {
                            title: window.sys_app_translate("Create Insurance", lang),
                            path: "/insurance-requests/create",
                        }
                        : null,
                    permissions[PSectionInsuranceRequests]["view-all"]
                        ? {
                            title: window.sys_app_translate("Insurances List", lang),
                            path: "/insurance-requests/view-all",
                        }
                        : null,
                ],
            }
            : null,
        permissions[PSectionBalanceRequests]["view-all"] ||
            permissions[PSectionBalanceRequests]["create"]
            ? {
                path: "balance",
                title: window.sys_app_translate("Balance", lang),
                subMenu: [
                    permissions[PSectionBalanceRequests]["create"]
                        ? {
                            title: window.sys_app_translate(
                                "Create Balance Request",
                                lang
                            ),
                            path: "/balance-requests/view-all",
                        }
                        : null,
                    permissions[PSectionBalanceRequests]["view-all"] && {
                        title: window.sys_app_translate("Balance Requests", lang),
                        path: "/balance-requests/view-all",
                    },
                ],
                icon: PSectionBalanceRequests,
            }
            : null,
        permissions[PSectionFinancialRequests]["view-all"]
            ? {
                path: PSectionFinancialRequests,
                title: window.sys_app_translate("Financial Requests", lang),
                subMenu: [
                    {
                        path: "/financial-requests/view-exported",
                        title: window.sys_app_translate(
                            "Financial Activity Report v2",
                            lang
                        ),
                    },
                ],
                icon: PSectionFinancialRequests,
            }
            : null,
        permissions[PSectionAgencies]["view-all"] || permissions[PSectionAgencies]["create"]
            ? {
                path: PSectionAgencies,
                title: window.sys_app_translate("Agencies", lang),
                subMenu: [
                    permissions[PSectionAgencies]["create"] && {
                        title: window.sys_app_translate("Add Agency", lang),
                        path: "/agencies/create",
                    },
                    permissions[PSectionAgencies]["view-all"] && {
                        title: window.sys_app_translate("Agencies List", lang),
                        path: "/agencies/view-all",
                    },
                ],
                icon: PSectionAgencies,
            }
            : null,

        permissions[PSectionUsers]["view-all"] || permissions[PSectionUsers]["create"]
            ? {
                path: PSectionUsers,
                title: window.sys_app_translate("Users", lang),
                subMenu: null,
                icon: PSectionUsers,
                subMenu: [
                    permissions[PSectionUsers]["create"] && {
                        title: window.sys_app_translate("Add User", lang),
                        path: "/users/create",
                    },
                    permissions[PSectionUsers]["view-all"] && {
                        title: window.sys_app_translate("Users List", lang),
                        path: "/users/view-all",
                    },
                    permissions[PSectionUsers]["profile"] && {
                        title: window.sys_app_translate("Profile", lang),
                        path: "/users/profile",
                    },
                ],
            }
            : null,
        permissions[PSectionAnnouncements] && permissions[PSectionAnnouncements]["view-all"]
            ? {
                path: PSectionAnnouncements,
                title: window.sys_app_translate("Announcements", lang),
                subMenu: null,
                icon: PSectionAnnouncements,
                subMenu: [
                    permissions[PSectionAnnouncements]["create"] && {
                        title: window.sys_app_translate("Add Announcement", lang),
                        path: "/announcements/create",
                    },
                    permissions[PSectionAnnouncements]["view-all"] && {
                        title: window.sys_app_translate("Announcements List", lang),
                        path: "/announcements/view-all",
                    },
                ],
            }
            : null,
        {
            path: "reports",
            title: window.sys_app_translate("Reports", lang),
            subMenu: [
                permissions[PSectionReports]["discount-rates-report"] && {
                    title: window.sys_app_translate("Agency Ratios", lang),
                    path: "/reports/agency-ratios",
                },
                permissions[PSectionReports][PermissionReportAdvancedReports] && {
                    title: window.sys_app_translate("Advanced Reports", lang),
                    path: "/reports/advanced-reports",
                },
            ],
            icon: "reports",
        },
    ]
}